import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/Toast';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Users from './pages/Users';
import Reports from './pages/Reports';
import WhatsAppKeys from './pages/WhatsAppKeys';
import WhatsAppDocs from './pages/WhatsAppDocs';
import SocialCountKeys from './pages/SocialCountKeys';
import SocialCountDocs from './pages/SocialCountDocs';
import InstagramCookies from './pages/InstagramCookies';
import TikTokCookies from './pages/TikTokCookies';
import OrderApiKeys from './pages/OrderApiKeys';
import Jobs from './pages/Jobs';
import Statistics from './pages/Statistics';
import AppVersions from './pages/AppVersions';
import ProxyManagement from './pages/ProxyManagement';
import SupportRequests from './pages/SupportRequests';
import ServiceActions from './pages/ServiceActions';
import TraoDoiSub from './pages/TraoDoiSub';
import TuongTacCheo from './pages/TuongTacCheo';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/orders" element={
                <ProtectedRoute>
                  <Orders />
                </ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              } />
              <Route path="/reports" element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              } />
              <Route path="/whatsapp" element={
                <ProtectedRoute>
                  <WhatsAppKeys />
                </ProtectedRoute>
              } />
              <Route path="/whatsapp/docs" element={
                <ProtectedRoute>
                  <WhatsAppDocs />
                </ProtectedRoute>
              } />
              <Route path="/social-count" element={
                <ProtectedRoute>
                  <SocialCountKeys />
                </ProtectedRoute>
              } />
              <Route path="/social-count/docs" element={
                <ProtectedRoute>
                  <SocialCountDocs />
                </ProtectedRoute>
              } />
              <Route path="/instagram-cookies" element={
                <ProtectedRoute>
                  <InstagramCookies />
                </ProtectedRoute>
              } />
              <Route path="/tiktok-cookies" element={
                <ProtectedRoute>
                  <TikTokCookies />
                </ProtectedRoute>
              } />
              <Route path="/api-keys" element={
                <ProtectedRoute>
                  <OrderApiKeys />
                </ProtectedRoute>
              } />
              <Route path="/jobs" element={
                <ProtectedRoute>
                  <Jobs />
                </ProtectedRoute>
              } />
              <Route path="/statistics" element={
                <ProtectedRoute>
                  <Statistics />
                </ProtectedRoute>
              } />
              <Route path="/app-versions" element={
                <ProtectedRoute>
                  <AppVersions />
                </ProtectedRoute>
              } />
              <Route path="/proxy-management" element={
                <ProtectedRoute>
                  <ProxyManagement />
                </ProtectedRoute>
              } />
              <Route path="/service-actions" element={
                <ProtectedRoute>
                  <ServiceActions />
                </ProtectedRoute>
              } />
              <Route path="/support-requests" element={
                <ProtectedRoute>
                  <SupportRequests />
                </ProtectedRoute>
              } />
              <Route path="/traodoisub" element={
                <ProtectedRoute>
                  <TraoDoiSub />
                </ProtectedRoute>
              } />
              <Route path="/tuongtaccheo" element={
                <ProtectedRoute>
                  <TuongTacCheo />
                </ProtectedRoute>
              } />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
